import { render } from "./GoToTop.vue?vue&type=template&id=4bf4fc7d&scoped=true"
import script from "./GoToTop.vue?vue&type=script&lang=js"
export * from "./GoToTop.vue?vue&type=script&lang=js"

import "./GoToTop.vue?vue&type=style&index=0&id=4bf4fc7d&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf4fc7d"]])

export default __exports__